var BaseSlider = require('../menu/slider');
var MenuItemThumb = require('./common/menu-item-thumb');
var MenuSlider = BaseSlider.extend({
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(options || {}, {
            shouldEnableOnlinePurhaseCallback: function (menuItem) {
                return false;
            },
            menuItemThumbOptions: {}
        });
        BaseSlider.prototype.initialize.call(this, self.options);
    },
    createSlide: function (item, displayImageURL) {
        var $deferred = $.Deferred();
        var self = this;
        $deferred.resolve(new MenuItemThumb(
            _.extend({
                    model: item,
                    displayImageURL: displayImageURL,
                    thumbStyle: 'full',
                    animationStyleShow: 'long',
                    imagePreloading: false,
                    appChannel: self.options.appChannel,
                    onlinePurchaseEnabled: self.options.shouldEnableOnlinePurhaseCallback(item),
                    showPricesPinned: false,
                    showPricesLast: true,
                    showTitleOverProductImage: true,
                    showMedicalAttrs: false,
                    showStrainIcon: false,
                    showStrainInEffectsRow: true,
                    menuItemPriceLayout: 'inline',
                    menuItemPriceLayoutSinglePrice: 'inline',
                    menuItemPricesTheme: 'dark'
                },
                self.options.menuItemThumbOptions
            )
        ));
        return $deferred.promise();
    }
});
module.exports = MenuSlider;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/menu-slider.js
 **/